<template>
  <div class="welcome px">
    <img class="logo" :src="images.welcome" v-if="!showLink" />
    <div class="text" v-if="!showLink">Welcome To Angry Miao</div>
    <div class="link" v-if="showLink">
      {{ $t("loader.link") }}
    </div>
    <c-progress
      v-if="percent >= 0 && percent <= 100"
      :percent="percent"
      :text="progressText"
      @close="onClose"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { Modal } from "ant-design-vue";

export default {
  data() {
    return {
      timer: 0,
      showLink: false,
      percent: -1,
      progressText: "",
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("loader", {
      inLoader: "inLoader",
      systemInfo: "systemInfo",
      bridge: "bridge",
    }),
  },
  methods: {
    updateFirmware() {
      if (this.systemInfo.isLatestVersion) return;
      this.$store.dispatch("loader/updateLoader");
    },
    onClose() {
      this.percent = -1;
      this.$store.dispatch("loader/restartLoader");
      window.location.reload();
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.$store.dispatch("loader/getSystemInfo");
      if (this.systemInfo.version == "1.3.0" && !this.systemInfo.isLatestVersion) {
        clearInterval(this.timer);
        this.$store.dispatch("loader/setLoading", true);
        Modal.destroyAll();
        this.$info({
          title: this.$t("loader.forceUpdate", ["AM Master"]),
          okText: this.$t("loader.update"),
          centered: true,
          onOk: () => {
            this.$store.dispatch("loader/updateLoader");
          },
        });
        return;
      }
      if (this.systemInfo.deviceList.length > 0) {
        clearInterval(this.timer);
        this.$router.replace(this.$paths.deviceList);
      } else if (this.bridge) {
        this.showLink = true;
      }
    }, 1000);

    window.updatingLoaderProgress = (json) => {
      if (json) {
        const data = JSON.parse(json);
        this.percent = data.progress;
        this.progressText = this.isCN ? data.message.zh_CN : data.message.en_US;
        if (this.percent === -1) {
          this.$info({
            title: this.$t("loader.failToUpdate"),
            width: "8.4rem",
            okText: this.$t("yes"),
            cancelText: this.$t("cancel"),
            centered: true,
          });
        }
      }
    };
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
</script>
<style lang="scss" scoped>
.welcome {
  width: 100%;
  height: 100vh;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .logo {
    width: 500px;
    height: auto;
    margin-bottom: 150px;
  }

  .text,
  .link {
    width: 800px;
    font-size: 76px;
    font-weight: 600;
    text-align: center;
    letter-spacing: 0;
    margin-bottom: 200px;
    margin-top: -30px;
    color: transparent;
    background: linear-gradient(270deg, #8743ff 0%, #4136f1 50%, #8743ff 100%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: scroll 1.5s linear infinite;
    display: inline;
  }

  .link {
    font-size: 72px;
    font-weight: 400;
    margin: 0;
  }
}

@keyframes scroll {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 800px 0;
  }
}
</style>
